<template>
  <el-col v-if="buttonList!=null&&buttonList.length>0" :span="24" class="toolbar headerBtnList" style="padding-top: 0px;float:none;">
    <el-form :inline="true" @submit.native.prevent>
      <!-- <el-form-item>
        <el-input v-model="searchVal" placeholder="请输入内容"></el-input>
      </el-form-item> -->
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button :loading="item.loading"  v-no-more-click :type="item.func&&(item.func.toLowerCase().indexOf('handledel')!= -1 ||item.func.toLowerCase().indexOf('stop')!= -1 )? 'danger':'primary'" v-if="!item.isHide" @click="callFunc(item)">{{item.name}}</el-button>
        <el-button @click="resetBtn" style="margin-left: 10px;"  v-no-more-click type="danger" v-if="showResetButton && item.name.trim() == '查询'">重置</el-button>
      </el-form-item>
    </el-form>
  </el-col>
</template>
<script>
export default {
  name: "Toolbar",
  data() {
    return {
      searchVal: "" //双向绑定搜索内容
    };
  },
  props: ["buttonList",'showResetButton'], //接受父组件传值
  methods: {
    callFunc(item) {
      //item.search = this.searchVal;
      this.$emit("callFunction", item); //将值传给父组件
    },
    resetBtn(){
      this.$emit('resetBtn','')
    }
  }
};
</script>